export const ClubRouting = {
    path: "/zhihuixinghejlb",
    query:{s:'h5_dailizhaomu'},
    name: "zhihuixinghejlb",
    meta: { title: "工程管理软件俱乐部" },
    component: () => import(/* webpackChunkName: "join" */ "@/views/join/h5/club/club.vue"),
    children: [],
  };
  